export default __webpack_public_path__ + "static/media/MangoReader.4f81c2cc.png";